import { z } from 'zod';
/**
 * Strada Set-call-session-data v1 Configuration Validator
 * Validates key-value data and TTL for Redis session data keyed by caller phone number
 */
export const Strada_Set_Data_1_ConfigValidator = z.object({
    data: z.record(z.string(), z.any()),
    ttlSeconds: z.number().min(1).default(180)
});
//# sourceMappingURL=strada-set-call-session-data-1.js.map